import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./base.api.ts";

interface LoginResponse {
  data: {
    agent_id: number;
    agent_username: string;
    agent_email: string;
    belongs_to_company_id: number;
    agent_role: number;
    agent_status: number;
    profile_url: string | null;
    createdAt: string;
    updatedAt: string;
    agentBelongsToCompany: {
      company_id: number;
      company_name: string;
      company_website: string;
      company_phone: string;
      company_scont_url: string;
      company_type: number;
      sector_type: string | null;
      sector_model: string | null;
      createdAt: string;
      updatedAt: string;
    };
  };
  message: string;
}

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: customBaseQuery,
  tagTypes: ['Auth', 'User'],
  endpoints: (builder) => ({
    loginUser: builder.mutation<LoginResponse, { agent_username: string; agent_password: string }>({
      query: (body) => ({
        url: "/api/authentication/agentLogin",
        method: "post",
        body,
      }),
      invalidatesTags: ['User']
    }),
    registerUser: builder.mutation({
      query: (body: {
        agent_company_name: string;
        agent_email: string;
        agent_username: string;
        agent_password: string
      }) => ({
        url: "/authentication/signUp",
        method: "post",
        body,
      }),
      invalidatesTags: ['User']
    }),
  }),
});

export const {
  useLoginUserMutation,
  useRegisterUserMutation,
} = authApi;